export const payloadData = {
  "/api/transaction/": {
    resultPL: `{
    "email": "support@youwebsite.cl",
    "order": "98745",
    "subject": "test subject",
    "amount": 25000,
    "currency": "CLP",
    "payment": 1,
    "urlreturn": "https://youwebsite.com/urlreturn?orderClient=98745",
    "urlnotify": "https://youwebsite.com/urlnotify?orderClient=98745",
    "additional_parameters": {
      "parameters1": "keyValue",
      "parameters2": "keyValue2",
      "order_ext": "fff-777"
    }
    }`,
  },
  "/api/escrow/": {
    resultPL: `{
    "transactions": [
      "trx3b4d77b43acd9a720",
      "trx3b4d77b43acd9a385"
      ]
    }`,
  },
  "/api/nullification/": {
    resultPL: `{
    "id": "trxpr2a45s1dytg1",
    "amount": 25000,
    "subject": "anulación transacción"
    }`,
  },
  "/api/maclient/": {
    resultPL: `{
    "email": "support@youwebsite.cl",
    "name": "Joe Doe",
    "phone": "923122312",
    "bank": {
      "sbif": "0001",
      "type": "1",
      "num": "12312313121",
      "rut": "111111111"
      }
    }`,
  },
  "/api/maaffiliation/": {
    resultPL: `{
    "name": "name",
    "percentage": "20",
    "affiliation": [
        [
        "madb93fc00a2cf6f4449",
        "80"
        ]
      ]
    }`,
  },
  "/api/mall/": {
    resultPL: `{
    "email": "joedoe@gmail.com",
    "merchant": [
        [
          "81b6179e4feeef2b50af71d660f830de",
          30000,
          "item1"
        ],
        [
          "bcf6c06c523d9394be41bc0174c43d1476f274abb342955aac93cc8014737b3b",
          25000,
          "item2"
        ],
        [
          "3952097d617679f98c587bad0b3a781d",
          15000,
          "item3"
        ]
      ],
    "order": 123,
    "urlreturn": "https://youwebsite.cl/urlreturn",
    "urlnotify": "https://youwebsite.cl/urlnotify"
    }`,
  },
  "/api/event/": {
    resultPL: `{
    "event": "98374",
    "name": "Event",
    "date_event": "2020-12-20",
    "date_closing_sales": "2020-12-19 23:59:00",
    "date_payment": "2020-12-20",
    "url_event": "https://example.cl/event1",
    "url_logo": "https://example.cl/logo_event1.png",
    "service_sale": 10,
    "affiliaction": [
        {
        "email": "afiliate1@domain.com",
        "percent": 50
        }
      ]
    }`,
  },
  "/api/suclient/": {
    resultPL: `{
    "email": "support@youwebsite.cl",
    "name": "Joe Doe",
    "rut": "11111111",
    "phone": "923122312",
    "address": "Moneda 101",
    "country": "Chile",
    "region": "Metropolitana",
    "city": "Santiago",
    "postal_code": "850000",
      "additional_parameters": {
      "parameter_1": "example",
      "parameter_2": "example"
      }
    }`,
  },
  "/api/suclient/customers": {
    resultPL: ``,
  },
  "/api/sususcription/": {
    resultPL: `{
    "plan": "pl9697fb170834ad42dd00",
    "client": "cl9b1e1dd988694f30fa30",
    "amount": "string"
    }`,
  },
  "/api/sususcriptionv3/": {
    resultPL: ``,
  },
  "/api/sutransaction/": {
    resultPL: `{
    "suscription": "sucaab7865dceaff49d8b3",
    "amount": "10000",
    "order": "001",
    "description": "Descripción"
    }`,
  },
  "/api/suinscriptionscards/": {
    resultPL: `{
    "suscription": "sucaab7865dceaff49d8b3"
    }`,
  },
  "/urlnotifysuscription/": {
    resultPL: `{
    "id": "su74866857980c7d2b4306",
    "status": "active"
    }`,
  },
  "/urlnotifypayment/": {
    resultPL: `{
    "transaction_id": 9123123,
    "verification_key": "2ba83615f863e72sdca5dfd0a6df2782",
    "order": 1568041684,
    "status": "success",
    "subscriptions": {
      "id": "su3ce571420e90b600eafb",
      "client": "cl795704ece0a3690baaf"
      }
    }`,
  },
  "/api/suplan/": {
    resultPL: `{
    "name": "Test plan",
    "description": "Test Plan",
    "url_notify_suscription": "https://youwebsite.com/urlnotifysuscription",
    "url_notify_payment": "https://youwebsite.com/urlnotifypayment",
    "url_success_payment": "https://youwebsite.com/urlsuccesspayment",
    "url_failed_payment": "https://youwebsite.com/urlfailedpayment"
    }`,
  },
  "/api/wallet/payout": {
    resultPL: `{
    "email": "support@youwebsite.cl",
    "phone": "923122312",
    "subject": "test subject",
    "currency": "CLP",
    "order": "98745",
    "amount": 25000,
    "accountbank_name": "José Manuel Muñoz Alarcon",
    "accountbank_rut": 111111111,
    "accountbank_sbif": "0001",
    "accountbank_type": "1",
    "accountbank_num": "12312312312",
      "additional_parameters":
      {
      "parameters1": "keyValue",
      "parameters2": "keyValue2",
      "order_ext": "fff-777"
      }
    }`,
  },
  "/api/wallet/withdraw/": {
    resultPL: `{
    "subject": "test subject",
    "currency": "CLP",
    "order": "98745",
    "amount": 25000
    }`,
  },
  "/api/wallet/": {
    resultPL: ``,
  },
  "/api/wallet/list": {
    resultPL: ``,
  },
  "/api/payout/": {
    resultPL: ``,
  },
  "/api/conciliation/": {
    resultPL: `{
      "date_init": "2023-01-19",
      "date_end": "2023-02-17"
    }`,
  },
};